import React, { Component, useState, useEffect, Fragment } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../common/loaderapp';
import axios from 'axios';
import notie from 'notie'
import tools from '../../js/tools2';
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImagePreview);

const SpeakersEdit = () => {
    let navigate = useNavigate();
    let params = useParams();
    const { id } = useParams();
    const [load, setLoad] = useState(true);
    const [speaker, setSpeaker] = useState({ name:'', information:'', price:'', picture:'', is_visible: true})
    const [key, setKey] = useState(0); 
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState(null);

    useEffect(() => {
        if(id != 0){
            fetch('/rt_publications', {
                method: 'PATCH',
                body: JSON.stringify({id}),
                headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then(res => {
				console.log('El speaker',res);
                if(res.length != 0){
                    const { ACTIVE_PUB, ID_PUB, IMAGE_PUB, INFORMATION_PUB,IS_VISIBLE_PUB, NAME_PUB, PRICE_PUB } = res.result[0];
                    setSpeaker({ name:NAME_PUB, information:INFORMATION_PUB, price:PRICE_PUB, picture:IMAGE_PUB, is_visible: IS_VISIBLE_PUB})
                }
            })
            .catch(err => console.log('Error: '+err))
        }
        setLoad(false);
    }, [])

    const { name, information, price, picture, is_visible } = speaker
    const actSpeaker=(e)=>setSpeaker({ ...speaker, [e.target.name]:(e.target.value)})
    
    function setInfo() {
        fetch('/rt_publications', {
            method: id != 0 ? 'PUT' : 'POST',
            body: JSON.stringify({...speaker,id}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => res.json())
        .then(res => {
            console.log('El speaker',res);
            navigate('/publications')
        })
        .catch(err => console.log('Error: '+err))
    }

    const handleFileChange = (event) => {
        console.log('FILE',event.target.files[0]);
        const selectedFile = event.target.files[0];
        if (selectedFile && !/^image\//.test(selectedFile.type)) {
            console.error('Invalid file type. Only images are allowed.');
            setKey((prevKey) => prevKey + 1);
            setFile(null);
        } else {
            setSpeaker({ ...speaker, 'picture':selectedFile.name})
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            try {
                const response = await axios.post('/uploadPublications', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log('File uploaded successfully:', response.data);
                setInfo();
            } catch (error) {
            console.error('Error uploading file:', error);
            }
        } else {
            console.error('No file selected');
            setInfo()
        }
    };

    const saveButton = () => {
        const form = tools.getForm2('formPublication', {ignore: ['inputFiles']})
        form.data.id = params.id
        let data = form.data
        const formData = new FormData()
        formData.append('datos', JSON.stringify(data))

        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                formData.append('files[]', files[i].file)
            }
        }

        if (form.isEmptyCount > 0) {
            return notie.alert({
                type: 'warning',
                text: `All fields must be filled in order to continue.`,
            })
        }

        tools.toolFetch({
            ruta: 'rt_publications',
            method: params.id == 0 ? 'POST' : 'PUT',
            body: formData,
            NoStringify: 1,
            NoHeaders: 1
        }, (response) => {
            if (response.estatus == 0) {
                return notie.alert({
                    type: 'warning', 
                    text: `An error ocurred while creating the publication.`,
                })
            }

            setTimeout(async () => {
                navigate('/publications')
            }, 2000);

            notie.alert({
                type: 'success',
                text: `Publication created successfully.`,
                position: 'top'
            })
        })
    }

    return (
        <Fragment>
            {load ? 
                <Loader/>: 
                <Fragment>
                    <form id="formPublication">
                        <div className="col-sm-12 mt-5 mb-5">
                            <div className="row">
                                <div className="col-sm-12 mb-2 mt-3">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <h5>Edit publication data</h5>
                                    <p>You can edit the name, photo and title, also you can add new publications or delete them.</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-12 mb-3">
                                    <label>Name:</label>
                                    <input className="form-control" id="name" name="name"  onChange={actSpeaker} value={name}></input>
                                </div>
                                <div className="form-group col-md-12 mb-3">
                                    <label>Information:</label>
                                    <textarea className="form-control" id="information" name="information" style={{minHeight:"280px"}} onChange={actSpeaker} value={information}></textarea>
                                </div>
                                <div className="form-group col-md-4 mb-4">
                                    <label className="form-label">Price:</label>
                                    <input type="text" className="form-control" id="price" name="price" value={price} onChange={actSpeaker}></input>
                                </div>
                                <div className="form-group col-md-8 mb-4">
                                    <label className="form-label">Picture: (400x400px)</label>
                                    <div className="inputUpload">
                                        {/* <input key={key} className="form-control"  type="file"  onChange={handleFileChange}></input> */}
                                        <FilePond
                                            files={files}
                                            onupdatefiles={setFiles}
                                            allowMultiple={true}
                                            allowImagePreview={true}
                                            maxFiles={1}
                                            name="inputFiles"
                                            id="inputFiles"
                                            labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                                        />
                                        <span className="inputUploadDec">Select picture <i class="fa-solid fa-upload"></i></span>
                                    </div>
                                </div>
                                <div className="form-group col-md-6 mb-5">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={is_visible} onChange={()=>{setSpeaker({...speaker, is_visible: !is_visible})}}></input>
                                        <label class="form-check-label" for="flexRadioDefault1">
                                            Public
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"  checked={!is_visible} onChange={()=>{setSpeaker({...speaker, is_visible: !is_visible})}}></input>
                                        <label class="form-check-label" for="flexRadioDefault2">
                                            Hidden
                                        </label>
                                    </div>
                                </div>
                                <div className="col-12 d-flex">
                                    <button type="button" className="btn btn-primary ms-auto" onClick={saveButton}>Save changes</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Fragment>
            }
        </Fragment>
    );
}

export default SpeakersEdit;